/* ============================================================
   VALOTERNA — Hinweis „In Ihrem Warenkorb“
   Datei: assets/cart-notification.js
   Gleiche öffentliche Methoden wie Dawn (renderContents,
   getSectionsToRender, setActiveElement, open, close),
   damit product-form.js & Co. unverändert weiterlaufen.
   ============================================================ */
class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );

    // Druck & Loslassen: gleiche Logik wie auf der Warenkorbseite
    const release = () => {
      this.pressed?.classList.remove('is-pressed');
      this.pressed = null;
    };
    this.addEventListener('pointerdown', (e) => {
      const b = e.target.closest('[data-vl-cn-press]');
      if (!b || e.button > 0) return;
      const r = b.getBoundingClientRect();
      b.style.setProperty('--px', `${e.clientX - r.left}px`);
      b.style.setProperty('--py', `${e.clientY - r.top}px`);
      b.classList.add('is-pressed');
      this.pressed = b;
    });
    document.addEventListener('pointerup', release);
    document.addEventListener('pointercancel', release);
    this.addEventListener('pointerout', (e) => {
      if (this.pressed && !this.pressed.contains(e.relatedTarget)) release();
    });

    this.addEventListener('click', (e) => {
      const co = e.target.closest('[data-vl-cn-checkout]');
      if (!co) return;
      if (co.classList.contains('is-leaving')) {
        e.preventDefault();
        return;
      }
      co.classList.add('is-leaving');
      co.setAttribute('aria-busy', 'true');
    });

    window.addEventListener('pageshow', (e) => {
      if (!e.persisted) return;
      this.querySelectorAll('[data-vl-cn-checkout]').forEach((b) => {
        b.classList.remove('is-leaving', 'is-pressed');
        b.removeAttribute('aria-busy');
      });
    });
  }

  open() {
    // Animationen der Inhalte bei jedem Öffnen neu starten
    this.notification.classList.remove('active');
    void this.notification.offsetWidth;
    this.notification.classList.add('animate', 'active');

    let focused = false;
    const focusIn = () => {
      if (focused) return;
      focused = true;
      this.notification.focus();
      trapFocus(this.notification);
    };
    this.notification.addEventListener('transitionend', focusIn, { once: true });
    setTimeout(focusIn, this.reduced.matches ? 0 : 650); // falls transitionend nicht feuert

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      const target = document.getElementById(section.id);
      const html = parsedState.sections?.[section.id];
      if (!target || !html) return;
      const inner = this.getSectionInnerHTML(html, section.selector);
      if (inner !== null) target.innerHTML = inner;
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return el ? el.innerHTML : null;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
